const autoNgTemplateLoaderTemplate1 = require('./eventsDatatable.html');

angular.module('shbdeployer.kubernetes').component('kubernetesEventsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    loading: '<',
    refreshCallback: '<',
  },
});
